<template>
  <div>
    <form @submit.prevent="submit">
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="card test">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <legend>{{ $t("measurement.Measurement") }}</legend>
                  <label for="customer_id">{{ $t("measurement.Customer") }}*</label>

                  <div v-if="this.isNew" class="d-inline-block">
                    <span class="badge badge-secondary ml-2 cursor-pointer" data-target="#klantModal"
                          data-toggle="modal">New</span>
                    <modal-klant></modal-klant>
                  </div>
                  <vue-bootstrap-typeahead
                      :data="customerResults"
                      :serializer="item => item.name"
                      @hit="customerSelect($event.id)"
                      id="customer_id"
                      name="customer_id"
                      ref="customersAutocomplete"
                      type="text"
                      v-bind:inputClass="this.customer_id.validated ? this.customer_id.valid ? 'is-valid' : 'is-invalid' : ''"
                      v-model="customerSearch"
                      v-validate="'required'"
                  />
                  <div class="invalid-feedback feedback-typeahead">{{
                      errors.first('customer_id')
                    }}
                  </div>
                  <div v-if="showTypes">
                    <label class="mt-2" for="customer_id">{{ $t("measurement.Type") }}</label>
                    <component-types-dropdown :customer="form.customer_id"
                                              :selected="component_type_id"
                                              id="component_type_id"
                                              name="component_type_id"
                                              v-model="component_type_id"></component-types-dropdown>
                  </div>

                  <div class="invalid-feedback d-block">{{ errors.first('component_type_id') }}</div>
                  <label class="mt-2" for="component_id">{{ $t("measurement.Packet") }}*</label>
                  <div v-if="this.isNew" class="d-inline-block">
                    <span class="badge badge-secondary ml-2 cursor-pointer" data-target="#componentModal"
                          data-toggle="modal">New</span>
                    <modal-component></modal-component>
                  </div>
                  <vue-bootstrap-typeahead
                      :data="componentResults"
                      :serializer="item => item.packet_number"
                      @hit="componentSelect($event)"
                      id="packet_id"
                      name="packet_id"
                      ref="componentAutocomplete"
                      type="text"
                      v-model="componentSearch"
                      v-validate="'required'"
                  />
                  <div class="invalid-feedback feedback-typeahead d-block">{{
                      errors.first('packet_id')
                    }}
                  </div>
                  <label>{{ $t("measurement.Component") }}*</label>
                  <select @change="packetChange($event)" class="form-control dropdown-bigger"
                          id="component_id" name="component_id" v-model="form.component_id"
                          v-validate="'required'">
                    <option :data-id="packet.id" :data-interval="packet.interval_control"
                            :data-type="packet.type"
                            :value="packet.id" v-bind:key="index"
                            v-for="(packet, index) in packetResults">{{ packet.number }}
                    </option>
                  </select>
                  <div class="invalid-feedback d-block">{{
                      errors.first('component_id')
                    }}
                  </div>

                  <div v-if="packet_type == 2">
                    <legend class="mt-3">{{ $t("measurement.Filter_measurements") }}</legend>
                    <div class="form-label-group">
                      <input class="form-control" id="back_pressure_rate"
                             name="back_pressure_rate"
                             type="text"
                             v-bind:class="[this.back_pressure_rate.validated ? this.back_pressure_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                             v-model="form.back_pressure_rate">
                      <label for="back_pressure_rate">{{ $t('measurement.Back_pressure_rate') }}</label>
                      <div class="invalid-feedback">{{ errors.first('back_pressure_rate') }}</div>
                    </div>
                    <div class="form-label-group">
                      <input class="form-control" id="leakage_rate" name="leakage_rate"
                             type="text"
                             v-bind:class="[this.leakage_rate.validated ? this.leakage_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                             v-model="form.leakage_rate">
                      <label for="leakage_rate">{{ $t('measurement.Leakage_rate') }}</label>
                      <div class="invalid-feedback">{{ errors.first('leakage_rate') }}</div>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" v-model="form.homogeneous" type="checkbox" value=""
                             id="flexCheckDefault" style="margin-top:7px">
                      <label class="form-check-label" for="flexCheckDefault">
                        Homogeen
                      </label>
                    </div>
                  </div>


                  <legend class="mt-3">{{ $t("measurement.Rates") }}</legend>
                  <div class="form-label-group">
                    <input class="form-control" id="weight_rate" name="weight_rate"
                           type="text"
                           v-bind:class="[this.weight_rate.validated ? this.weight_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                           v-model="form.weight_rate">
                    <label for="weight_rate">{{ $t('measurement.Weight_rate') }}</label>
                    <div class="invalid-feedback">{{ errors.first('weight_rate') }}</div>
                  </div>
                  <div class="form-group">
                    <label for="pollution_rate">{{ $t("measurement.Pollution_rate") }}</label>
                    <span class="pollution-rate-result-label">{{ form.pollution_rate }}</span>
                    <input class="custom-range"
                           id="pollution_rate"
                           name="pollution_rate"
                           type="range"
                           min="1"
                           max="5"
                           v-bind:class="[this.pollution_rate.validated ? this.pollution_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                           v-model="form.pollution_rate"
                    >
                    <span class="pollution-rate-slider-label" style="float:left">{{ $t('measurement.Clean') }}</span>
                    <span class="pollution-rate-slider-label" style="float:right">{{ $t('measurement.Dirty') }}</span>
                    <div class="invalid-feedback">{{ errors.first('pollutionRate') }}</div>
                  </div>
                  <div class="form-group">
                    <label for="pollution_rate">{{ $t("measurement.Wear_rate") }}</label>
                    <span class="pollution-rate-result-label">{{ form.wear_rate }}</span>
                    <input class="custom-range"
                           id="wear_rate"
                           name="wear_rate"
                           type="range"
                           min="1"
                           max="5"
                           v-bind:class="[this.wear_rate.validated ? this.wear_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                           v-model="form.wear_rate"
                    >
                    <span class="pollution-rate-slider-label" style="float:left">{{ $t('measurement.None') }}</span>
                    <span class="pollution-rate-slider-label" style="float:right">{{ $t('measurement.Much') }}</span>
                    <div class="invalid-feedback">{{ errors.first('wearRate') }}</div>
                  </div>
                </div>
                <div class="col-6">
                  <legend>{{ $t("measurement.Date") }}</legend>
                  <div class="form-group">
                    <VueCtkDateTimePicker :no-button="true" :only-date="true"
                                          @input="form.control_date = moment(form.in_date).add(intervalControl, 'M').format('Y-MM-DD')"
                                          format="YYYY-MM-DD"
                                          formatted="DD/MM/YYYY" id="in_date"
                                          label="In" v-model="form.in_date"
                    ></VueCtkDateTimePicker>
                  </div>
                  <div class="form-group">
                    <VueCtkDateTimePicker :no-button="true" :only-date="true"
                                          format="YYYY-MM-DD"
                                          formatted="DD/MM/YYYY" id="out_date"
                                          label="Out" v-model="form.out_date"
                    ></VueCtkDateTimePicker>
                  </div>
                  <div class="form-group">
                    <VueCtkDateTimePicker :label="$t('component.IntervalControl')" :no-button="true"
                                          :only-date="true"
                                          format="YYYY-MM-DD"
                                          formatted="DD/MM/YYYY"
                                          id="control_date"
                                          name="control_date" v-model="form.control_date"
                                          v-validate="'required'"
                    ></VueCtkDateTimePicker>
                    <div class="invalid-feedback d-block">{{ errors.first('control_date') }}</div>
                  </div>
                  <legend>Extra</legend>
                  <div class="form-label-group">
                                        <textarea class="form-control" id="note" name="note" placeholder="Enter token"
                                                  rows="3"
                                                  type="text"
                                                  v-bind:class="[this.note.validated ? this.note.valid ? 'is-valid' : 'is-invalid' : '']"
                                                  v-model="form.note"></textarea>
                    <label for="note">{{ $t('measurement.Note') }}</label>
                    <div class="invalid-feedback">{{ errors.first('note') }}</div>

                  </div>
                  <div v-if="isNew">
                    <input id="file" multiple ref="file" type="file" v-on:change="handleFileUpload()" />
                    <a :href="file.url" :key="index" target="_blank"
                       v-for="(file, index) in form.files">
                      <img :src="file.url" class="img-thumbnail m-1 w-50">
                    </a>
                  </div>
                  <div v-if="!isNew">
                    <input class="file-upload-field" id="file2" multiple ref="file" type="file" v-on:change="handleFileUpload()" />
                    <a @click="handleFileUploadData()" class="btn btn-default my-2 mb-4 btn-xs btn-upload">Upload</a>
                    <div :key="index" v-for="(file, index) in uploadedFiles">
                      <a :href="file.url" target="_blank"
                      >
                        <img :src="file.url" class="img-thumbnail mb-1 w-50">
                      </a>
                      <a class="btn btn-neutral delete-file" @click="handleFileDelete(file.id)">Delete</a>
                    </div>
                  </div>
                  <div v-if="this.lastMeasurement">
                    <legend class="mt-3">Last measurement</legend>
                    <div class="row">
                      <div class="col-3">
                        <label>Date</label>
                      </div>
                      <div class="col-7">
                        {{ moment(this.lastMeasurement.date).format('D/M/Y') }}
                      </div>
                      <div class="col-3">
                        <label>{{ $t("measurement.Pollution_rate") }}</label>
                      </div>
                      <div v-if="this.lastMeasurement.measurement">
                        <div class="col-7">
                          <PollutionBar
                              :data="this.lastMeasurement.measurement.pollution_rate"></PollutionBar>
                        </div>
                        <div class="col-3">
                          <label>{{ $t("measurement.Wear_rate") }}</label>
                        </div>
                        <div class="col-7">
                          <PollutionBar
                              :data="this.lastMeasurement.measurement.wear_rate"></PollutionBar>
                        </div>
                        <div class="col-3">
                          <label>{{ $t('measurement.Back_pressure_rate') }}</label>
                        </div>
                        <div class="col-7">
                          {{ this.lastMeasurement.measurement.back_pressure_rate }}
                        </div>
                        <div class="col-3">
                          <label>{{ $t('measurement.Leakage_rate') }}</label>
                        </div>
                        <div class="col-7">
                          {{ this.lastMeasurement.measurement.leakage_rate }}
                        </div>
                        <div class="col-3">
                          <label>{{ $t('measurement.Weight_rate') }}</label>
                        </div>
                        <div class="col-7">
                          {{ this.lastMeasurement.measurement.weight_rate }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary mt-4" type="submit">{{ $t('global.Submit') }}</button>
              <button @click="reset()" class="btn btn-outline-default mt-4 ml-2" type="button"
                      v-if="isNew">
                {{ $t('global.Reset') }}
              </button>
              <button @click="deleteMeasurement()" class="btn btn-neutral red mt-4 ml-2" type="button"
                      v-if="!isNew">
                {{ $t('global.Delete') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div>

    </div>
  </div>
</template>
<script>
import {mapFields} from 'vee-validate'
import _ from 'underscore'
import ComponentTypesDropdown from '@/components/ComponentTypesDropdown.vue'
import PacketDropdown from '@/components/PacketDropdown.vue'
import PollutionBar from "@/components/PollutionBar"
import ModalKlant from "@/views/customer/Modal.vue"
import ModalType from "@/views/componenttype/Modal.vue"
import ModalComponent from "@/views/component/Modal.vue"

export default {
  name: 'appCreate',
  data() {
    return {
      isNew: true,
      dispatchLink: 'SAVE_MEASUREMENT',
      error: '',
      checkbox: true,
      customerResults: [],
      customerSelected: null,
      customerSearch: '',
      componentResults: [],
      componentSelected: null,
      componentSearch: '',
      intervalControl: '',
      packetResults: [],
      files: '',
      uploadedFiles: [],
      showTypes: true,
      packet_id: '',
      component_id: '',
      packet_type: '',
      // component_type_id: '',
      form: this.initForm(),
      lastMeasurement: null
    }
  },
  components: {
    ComponentTypesDropdown,
    PacketDropdown,
    PollutionBar,
    ModalKlant,
    ModalType,
    ModalComponent
  },
  computed: {
    ...mapFields(['customer_id', 'in_date', 'out_date', 'control_date', 'note', 'pollution_rate', 'wear_rate', 'weight_rate', 'back_pressure_rate', 'leakage_rate']),
    component_type_id: {
      get() {
        return this.$store.getters.getSelectedType
      },
      set(val) {
        this.$store.commit('SET_SELECTED_TYPE', val)
      }
    }
  },
  async mounted() {
    //Check create or update
    this.isNew = true;
    this.showTypes = true;
    this.dispatchLink = 'SAVE_MEASUREMENT';
    if (this.$route.params.id) {
      this.isNew = false;
      this.showTypes = false;
      this.dispatchLink = 'UPDATE_MEASUREMENT';

      let measurement = await this.$store.dispatch('GET_MEASUREMENT', {
        id: this.$route.params.id,
        customer_id: this.$route.params.customer_id,
        component_id: this.$route.params.component_id
      })

      this.form = measurement
      this.uploadedFiles = this.form.files
      delete this.form.files
      this.form.customer_id = measurement.relations.component.customer_id
      this.form.component_id = measurement.relations.component.id
      this.component_id = measurement.relations.component.packet_number
      await this.customerSelect(this.form.customer_id)
      this.typesLoaded = true;
      this.$refs.customersAutocomplete.$data.inputValue = this.customerSearch = measurement.relations.component.relations.customer.name
      this.$refs.componentAutocomplete.$data.inputValue = this.componentSearch = measurement.relations.component.packet_number

      this.component_type_id = this.$store.getters.getSelectedType

      //Bij update pakket nummer en type inladen
      this.getPackets()
      this.packet_type = measurement.relations.component.type
    } else {
      this.form.out_date = this.moment().format('Y-MM-DD')
      //Autofocus op customer field
      document.querySelector('#customer_id input').focus();
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.form.homogeneous === true) {
            this.form.homogeneous = 1
          } else {
            this.form.homogeneous = 0
          }
          let formData = new FormData();
          if (this.isNew) {
            //Formdata object aanmaken om files te uploaden

            for (var i = 0; i < this.files.length; i++) {
              let file = this.files[i];

              formData.append('files[' + i + ']', file);
            }

            for (var key in this.form) {
              formData.append(key, this.form [key]);
            }
          }

          let payload = {
            'form': (this.isNew) ? formData : this.form,
            'payload': this.form
          }


          // let data = this.form
          // data.id = this.$route.params.id
          // data.customer_id = this.$route.params.customer_id
          // data.component_id = this.$route.params.component_id
          this.$store.dispatch(this.dispatchLink, payload)
              .then(() => {
                this.$swal({
                  title: this.$t('swal.logout.SuccessTitle'),
                  text: this.$t('swal.logout.SuccessMsg'),
                  type: "success",
                  toast: true,
                  showConfirmButton: false,
                  position: 'top-end',
                  timer: 1200
                });

                if (this.isNew) {
                  //Form leegmaken
                  this.form.pollution_rate = 50
                  this.form.wear_rate = 50
                  this.form.note = ''
                  this.form.component_id = ''
                  this.form.leakage_rate = ''
                  this.form.weight_rate = ''
                  this.form.back_pressure_rate = ''
                  this.lastMeasurement = null

                  //Clear image
                  this.files = ''
                  document.getElementById('file').value = "";

                  this.$validator.reset()
                  document.querySelector('#packetDropdown').focus();
                }
              })
              .catch((error) => {
                if (error.errors.name) {
                  this.$validator.errors.add({
                    field: 'name',
                    msg: error.errors.name[0]
                  })
                  this.fieldsVee.name.valid = false
                }
              })
        }
      })
    },
    //Stappen van de slider opdelen per 10
    // sliderSteps() {
    //     this.form.pollution_rate = Math.ceil(this.form.pollution_rate / 10) * 10
    //     this.form.wear_rate = Math.ceil(this.form.wear_rate / 10) * 10
    // },
    customerSelect(id) {
      this.form.customer_id = id;
    },
    componentSelect(event) {
      this.component_id = event.packet_number
      this.intervalControl = event.interval_control
      this.getPackets()

    },
    //Customers ophalen via autocomplete
    async getCustomers(query) {
      await this.$store.dispatch('DROPDOWN_CUSTOMER', query).then((res) => {
        this.customerResults = res
      })
    },
    //Components ophalen via autocomplete
    async getComponents(query) {
      let data = {
        query: query,
        customer: this.form.customer_id,
        type_id: this.component_type_id
      }
      await this.$store.dispatch('DROPDOWN_COMPONENT', data).then((res) => {
        this.componentResults = res
      })
    },
    //Packets ophalen als er een component gekozen is
    async getPackets() {
      let data = {
        customer: this.form.customer_id,
        type_id: this.component_type_id,
        number: this.component_id
      }

      await this.$store.dispatch('DROPDOWN_COMPONENT', data).then((res) => {
        this.packetResults = res
      })
    },
    handleFileUpload() {
      this.files = this.$refs.file.files;
    },
    handleFileDelete(id) {
      this.$swal({
        title: this.$t('swal.general.Title'),
        text: this.$t('swal.delete.Text'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t('swal.general.CancelButtonText'),
        confirmButtonText: this.$t('swal.delete.ConfirmButtonText')
      }).then(async (result) => {
            //Sure? -> Delete
            let data = {
              measurement_id: this.form.id,
              id: id
            }
            this.$store.dispatch('REMOVE_FILE', data).then((res) => {
              this.uploadedFiles = res.data
            })
          }
      )

    },
    handleFileUploadData() {
      let formData = new FormData();
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];

        formData.append('files[' + i + ']', file);
      }

      let payload = {
        measurement_id: this.form.id,
        files: formData
      }
      this.$store.dispatch('SAVE_FILES', payload).then((res) => {
        this.uploadedFiles = res.data
      })
    },
    reset() {
      this.form = this.initForm()
      this.$refs.componentAutocomplete.$data.inputValue = ''
      this.$refs.customersAutocomplete.$data.inputValue = ''
      this.component_type_id = ''

      //Clear image
      this.files = ''
      document.getElementById('file').value = "";
      document.querySelector('#customer_id input').focus();
    },
    initForm() {
      this.$validator.reset()
      this.lastMeasurement = null
      return {
        customer_id: '',
        component_id: '',
        pollution_rate: 3,
        wear_rate: 3,
        in_date: '',
        out_date: '',
        control_date: '',
        note: '',
        approved: 0,
        leakage_rate: '',
        back_pressure_rate: '',
        weight_rate: '',
        homogeneous: ''
      }
    },
    //Delete measurement
    deleteMeasurement() {

      //Confirmation dialog, are you sure?
      this.$swal({
        title: this.$t('swal.general.Title'),
        text: this.$t('swal.delete.Text'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t('swal.general.CancelButtonText'),
        confirmButtonText: this.$t('swal.delete.ConfirmButtonText')
      }).then(async (result) => {
            //Sure? -> Delete
            if (result.value) {

              let resp = await this.$store.dispatch('DELETE_MEASUREMENT', this.form)

              //Success message
              this.$swal({
                title: this.$t('swal.delete.SuccessTitle'),
                text: resp.message,
                type: "success",
                toast: true,
                showConfirmButton: false,
                position: 'top-end',
                timer: 1200
              });

              //Terugsturen naar index
              this.$router.push({name: 'measurementIndex'})
            }
          }
      )
    },
    //Actie voor onchange wanneer pakket gewijzigd wordt
    packetChange(index) {
      //Set interval control voor nieuwe controle
      let target = index.target.selectedOptions[0].dataset
      this.intervalControl = target.interval
      this.packet_type = target.type
      this.getLastMeasurement(target.id)
    },
    //Laatste meting ophalen in array van packetresults
    getLastMeasurement(componentId) {
      for (let key in this.packetResults) {
        let measurement = this.packetResults[key]
        if (measurement.id == componentId) {
          this.lastMeasurement = measurement.last_measurement_output
        }
      }
    }
  },
  watch: {
    customerSearch: _.debounce(function (addr) {
      this.getCustomers(addr)
    }, 500),
    componentSearch: _.debounce(function (addr) {
      this.getComponents(addr)
      if (!this.componentSearch) {
        this.showTypes = true;
      }
    }, 500),
    //Naar new measurement? Clear form
    $route() {
      this.isNew = true;
      this.showTypes = true;
      this.dispatchLink = 'SAVE_MEASUREMENT';
      this.reset()
    }
  }
}
</script>
<style>
.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.pollution-rate-slider-label {
  color: rgb(197, 197, 197);
  font-size: 12px;
  margin-top: -5px;
}

.pollution-rate-result-label {
  color: rgb(150, 150, 150);
  font-size: 16px;
  float: right;
}
.delete-file{
  color:red!important;
}
.file-upload-field{
  border: 1px solid #ced4da;
  border-radius: 5px;
  padding: 15px;
  width: 100%;
}
.btn-upload{
  background-color: #dee2e6;
  border-color: #dee2e6;
  line-height: 0.75;
}
.btn-upload:hover{
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}
</style>
